/* eslint-disable no-template-curly-in-string */

export const REQUIRED_FIELD_ERROR = 'El ${label} es obligatorio'
export const REQUIRED_FIELD_ERROR_FEM = 'La ${label} es obligatoria'
export const NO_NUMBERS_ERROR = 'El ${label} no puede contener números'
export const FIELD_INVALID = 'El ${label} introducido es inválido'
export const FIELD_INVALID_FEM = 'La ${label} introducida es inválida'
export const DATA_ERROR = 'Los datos introducidos son erróneos'
export const MAX_AGE_ERROR = 'El usuario debe ser mayor de edad'
export const MIN_AGE_ERROR = 'El usuario no puede ser tan mayor'
export const MAX_DATE_ERROR = 'La fecha de ${label} debe ser anterior'
export const MIN_DATE_ERROR = 'La fecha de ${label} debe ser posterior'
export const INVALID_DATE = 'El formato de fecha es inválido'
